import { SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import ButtonBarComponent from "src/components/user/button-bar-component";
import ChildrenListComponent from "src/components/user/sons-list-component";
import FavoriteSchoolsComponent from "src/components/user/favorite-schools-component";
import ParentEditProfileFormComponent from "src/components/user/parent-edit-profile-form-component";
import ProfileCardComponent from "src/components/user/profile-card-component";
import RequestsListComponent from "src/components/user/requests-list-component";
import WhatsAppIcon from "src/components/common/whats-app-icon";

function ProfileParentConatiner() {
  const { i18n } = useTranslation();
  const [showEditProfileForm, setShowEditProfileForm] =
    useState<Boolean>(false);
  const [activeButtonIndex, setActiveButtonIndex] = useState(0);

  const handleButtonClick = (index: SetStateAction<number>) => {
    setActiveButtonIndex(index);
  };
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="flex flex-col h-screen mobile:h-screen relative items-center pt-52 mobile:pt-10 mobile:bg-zinc-50"
    >
      <div>
        {showEditProfileForm ? (
          <div className="flex flex-col gap-6">
            <div className="laptop:hidden largeLaptop:hidden desktop:hidden largeDesktop:hidden">
              <ProfileCardComponent
                onClick={() => {
                  setShowEditProfileForm(true);
                }}
                image={"/assets/images/profile-icon.png"}
                name={"Saad saleh"}
                country={i18n.language === "ar" ? "السعودية" : "Saudi arabia"}
              />
            </div>
            <ParentEditProfileFormComponent />
          </div>
        ) : (
          <div className="flex flex-col mobile:items-center">
            <ProfileCardComponent
              image={"/assets/images/profile-icon.png"}
              name={"Saad saleh"}
              country={i18n.language === "ar" ? "السعودية" : "Saudi arabia"}
              onClick={() => {
                setShowEditProfileForm(true);
              }}
            />
            <ButtonBarComponent onButtonClick={handleButtonClick} />
            {activeButtonIndex === 0 && <FavoriteSchoolsComponent />}
            {activeButtonIndex === 1 && <RequestsListComponent />}
            {activeButtonIndex === 2 && <ChildrenListComponent />}
            {activeButtonIndex === 3 && <></>}
            {activeButtonIndex === 4 && <></>}
          </div>
        )}
      </div>
      <WhatsAppIcon />
    </div>
  );
}

export default ProfileParentConatiner;
